import Types from '../types';

const toggleSidebarMinimize = () => ({
  type: Types.TOGGLE_SIDEBAR_MINIMIZE,
});

export default toggleSidebarMinimize;
